import React, { useState } from "react";
import Image from "next/image";
import GavelModal from "../modals/GavelModal";

const CertificateInfo = ({ villa }) => {
  const [openModal, setOpenModal] = useState(false);
  return (
    <>
      <button
        type="button"
        disabled={!villa.gavelFileName}
        onClick={() => setOpenModal(true)}
        className="flex items-center justify-between gap-3 rounded-[10px] py-2 px-4 bg-[#FBEBEC]"
      >
        <Image
          src="/icons/kultur-bakanligi.svg"
          width={105}
          height={38}
          alt="Kultur Bakanlığı"
          className="object-cover"
        />
        <div className="flex flex-col">
          <span className="text-themeBlack text-size-10 font-medium leading-[14px]">
            BELGE NO
          </span>
          <span className="text-themeBlack text-sm font-extrabold leading-[14px]">
            {villa.gavelBelgeNo}
          </span>
        </div>
        {villa.gavelFileName && (
          <span className="text-themeBlack text-sm font-medium leading-[14px]">
            Göster
          </span>
        )}
      </button>
      <GavelModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        gavelFileName={villa.gavelFileName}
        villaName={villa.name}
      />
    </>
  );
};

export default CertificateInfo;
